import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategorise } from '../../../../../mechanics/rid-categorise/rid-categorise';

@Component({
  selector: 'app-categorise-mixed-page',
  imports: [RidCategorise],
  templateUrl: './categorise-mixed-page.html',
})
export class CategoriseMixedPage {
  protected readonly $router = inject(Router);
}
